export const getLs = (key) => window.localStorage.getItem(key)
export const setLs = (key, value) => window.localStorage.setItem(key, value)
